import React, { useState, useEffect } from 'react';
import { getDescription } from '../util/fetchRomDescription';
import { LocaleString } from '@nackle/intl-tools';
import { Button, Modal, Skeleton } from '@nackle/origami';

const IntroductionDialog = ( props ) => {
    const [ isLoading, setIsLoading ] = useState( false );
    const [ dynamicRomDescription, setDynamicRomDescription ] = useState( '' );
    const [ isDescriptionLoading, setIsDescriptionLoading ] = useState( true );

    const {
        open,
        onClose,
        romId,
        localeCode,
        onPlay,
        session,
        isUmbrella,
        env
    } = props;


    // Remove separate cache population; handle in description effect

    // Fetch description when romId / locale changes, ensuring cache is ready
    useEffect( () => {
        let isMounted = true;

        async function loadRomDescription() {
            if ( !romId || !localeCode ) {return;}

            setIsDescriptionLoading( true );

            try {
                // Ensure cache is loaded before fetching description
                const res = await getDescription( romId, localeCode, session, isUmbrella, env );
                if ( isMounted ) {
                    setDynamicRomDescription( res?.description || '' );
                }
            } catch ( error ) {
                console.error( 'Error fetching ROM description:', error );
                if ( isMounted ) {
                    setDynamicRomDescription( '' );
                }
            } finally {
                if ( isMounted ) {
                    setIsDescriptionLoading( false );
                }
            }
        }

        loadRomDescription();

        return () => {
            isMounted = false; // prevent state update after unmount
        };
    }, [ romId, localeCode ] );

    const handleClickPlay = async () => {
        setIsLoading( true );
        try {
            await onPlay();
        } finally {
            setIsLoading( false );
        }
    };

    return (
        <Modal
            getContainer=".game-container"
            maskClosable={ false }
            closable={ true }
            onCancel={ onClose }
            className="help-introduction-modal"
            centered
            open={ open }
            title={ <LocaleString code="game.loader.INTRODUCTION.MODAL.HEADER" /> }
            footer={ [
                (
                    <Button
                        key="cancel"
                        disabled={ isLoading }
                        id="introduction_dialog_cancel"
                        size="large"
                        onClick={ onClose }
                    >
                        <LocaleString code="game.loader.INTRODUCTION.MODAL.CANCEL.BUTTON" />
                    </Button>
                ),
                (
                    <Button
                        key="play"
                        data-testid="play-game-button"
                        id="introduction_dialog_play"
                        type="primary"
                        size="large"
                        loading={ isLoading }
                        onClick={ handleClickPlay }
                    >
                        <LocaleString code="game.loader.INTRODUCTION.MODAL.PLAY.BUTTON" />
                    </Button>
                ),
            ] }
        >
            { isDescriptionLoading ? (
                <Skeleton active paragraph={ { rows: 1 } } />
            ) : (
                dynamicRomDescription
            ) }
        </Modal>
    );
};

export default IntroductionDialog;